<template>
  <div class="unused-charger">

    <div class="row">
      <div class="col">
        <div class="card shadow">
          <div class="card-body">

            <div class="row">
              <div class="col-xl-3">
                <b-form-group label-class="col-form-label"
                              label="충전소" label-for="searchStation"
                              label-cols="3" content-cols="9">
                  <multiselect id="searchStation"
                               v-model="selectedStation" :options="stationOptions"
                               label="placeName" placeholder="" select-label=""
                               :allow-empty="false" deselect-label=""
                               :max-height="202" @input="search">
                    <span slot="noResult">No Result</span>
                  </multiselect>
                </b-form-group>
              </div>
<!--              <search-buttons layout-class="col-xl-4 offset-xl-4 ct-margin-top-25"-->
<!--                              resetBtnClass="search-btn-reset" searchBtnClass="search-btn-search"-->
<!--                              :reset-fn="reset" :search-fn="search" />-->
            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <div class="card shadow mb-0">
          <div class="card-body pb-0">

            <div class="row">
              <div class="col-xl-5">
                <div class="card">
                  <div class="card-body">
                    <card-title icon-image="mdi-battery-alert" title="장기 미사용 충전기 현황" text-color="title"/>
                    <div class="row d-flex align-items-center">
                      <div class="col-5">
                        <apexchart height="180"
                                   :options="unusedPercentChartOptions" :series="unusedPercentChartSeries" />
                      </div>
                      <div class="col-7">
                        <div class="ps-1 fw-bold">• 기간별 미사용 충전기 수량</div>
                        <apexchart height="180"
                                   :options="unusedPeriodChartOptions" :series="unusedPeriodChartSeries" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 h-100">
                <div class="card">
                  <div class="card-body">
                    <card-title icon-image="mdi-podium-gold" title="장기 미사용 충전기 순위" text-color="title"/>
                    <div class="ranking-list">
                      <div v-for="(info, i) in unusedTopFive" class="ranking-line rounded-pill">
                        <div class="number-round rounded-circle">
                          {{ i+1 }}
                        </div>
                        <span>
                        {{ info.csoEvseNum }}
                      </span>
                        <span>
                        {{ info.goneDay }} 일
                      </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-4">
                <div class="card">
                  <div class="card-body">
                    <div class="row">
                      <card-title icon-image="mdi-calendar-month" title="월별 장기 미사용 발생 추이" text-color="title" class="col-auto"/>
                      <div class="col text-end text-secondary">*최근 6개월</div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <apexchart height="200"
                                   :options="monthlyUnusedCountChartOptions" :series="monthlyUnusedCountChartSeries" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <div class="card">
                  <div class="card-body">
                    <div class="row mb-2">
                      <div class="col-auto">
                        <card-title icon-image="mdi-table-large" title="장기 미사용 목록" text-color="title" style="margin-bottom: 0 !important;"/>
                      </div>
                      <div class="col pt-3 pe-3">
                        <div class="text-end align-items-end">
                          <span class="text-secondary ms-3">전체 | </span>
                          <span class="fw-bold">{{ items.length }}</span>
                          <span class="text-secondary ms-1">기</span>
                        </div>
                      </div>
                    </div>

                    <div class="common-sticky-table border">
                      <b-table class="datatables text-nowrap text-center"
                               show-empty
                               responsive sticky-header="265px"
                               :fields="fields" :items="items">
                        <template #cell(goneDay)="data">
                          {{ data.item.goneDay }}일
                        </template>
                      </b-table>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import SearchButtons from "@/views/components/searchButtons.vue";
import CardTitle from "@/views/components/cardTitle.vue";
import { http } from "@/mdk/auth-api";
import TotalCount from "@/views/components/totalCount.vue";

export default {
  name: "unusedCharger",
  components: { TotalCount, CardTitle, SearchButtons, Multiselect },
  data() {
    return {
      stationOptions: [],
      unusedData: {},
      selectedStation: {},
      unusedPercentChartSeries: [],
      unusedPercentChartOptions: {
        chart: {
          type: 'donut',
          toolbar: { show: false, },
          selection: {
            enabled: false,
          },
          fontFamily: 'NanumSquareRound',
        },
        legend: { show: false },
        colors: ['#bde513', '#f4f4f4'],
        dataLabels: {
          enabled: true,
          enabledOnSeries: [0],
          formatter: (value, { seriesIndex, dataPointIndex, w }) => {
            const total = w.config.series.reduce((a, b) => a + b)
            return seriesIndex === 0 ? `${Math.round((w.config.series[0] / total) * 100)}%` : ''
          },
          textAnchor: 'middle',
          style: {
            fontSize: '12px',
            fontWeight: 400,
            colors: ['#ffffff'],
          },
          background: {
            enabled: true,
            padding: 5,
            foreColor: '#78a600',
            borderRadius: 2,
            borderWidth: 1,
            borderColor: '#78a600',
            opacity: 0.9,
          },
          dropShadow: {
            enabled: false,
          }
        },
        subtitle: {
          align: 'center',
          offsetY: 115,
          floating: true,
          style: {
            color:  '#858585',
          }
        },
        plotOptions: {
          pie: {
            expandOnClick: false,
            dataLabels: {
              minAngleToShowLabel: 1
            },
            donut: {
              size: '82%',
              labels: {
                show: true,
                name: {
                  show: true,
                  offsetY: -25,
                },
                value: {
                  show: true,
                  fontSize: '30px',
                  fontWeight: 400,
                  offsetY: -5,
                },
                total: {
                  show: true,
                  showAlways: true,
                  label: '미사용',
                  fontSize: '15px',
                  fontWeight: 600,
                  color: '#78a600',
                  formatter: w => `${w.globals.seriesTotals[0].toLocaleString()}기`
                }
              }
            }
          }
        },
        labels: ['미사용', '사용'],
        stroke: {
          show: false,
        },
        tooltip: {
          enabled: true,
          fillSeriesColor: false,
          theme: 'light',
          y: {
            formatter: val => `${val.toLocaleString()} 기`,
          },
        },
        grid: {
          padding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
          },
        },
        states: {
          hover: {
            filter: {
              type: 'none',
            }
          },
          active: {
            filter: {
              type: 'none',
            }
          },
        },
        noData: {
          text: 'Loading...',
          offsetY: -20,
          style: {
            color: '#858585',
          }
        }
      },
      unusedPeriodChartSeries: [],
      unusedPeriodChartOptions: {
        chart: {
          type: 'bar',
          toolbar: { show: false },
          parentHeightOffset: 0,
          fontFamily: 'NanumSquareRound',
        },
        colors: ['#bde513'],
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: '50%',
          }
        },
        dataLabels: { enabled: false },
        legend: { show: false },
        xaxis: {
          categories: ['30일 ~ 59일', '60일 ~ 89일', '90일 이상']
        },
        yaxis: {
          tickAmount: 2,
          forceNiceScale: true,
          max: max => max < 5 ? 4 : Math.ceil(max / 10) * 10,
          labels: {
            formatter: val => val.toLocaleString()
          }
        },
        tooltip: {
          x: { show: false },
          y: {
            formatter: val => `${val.toLocaleString()} 기`,
            title: {
              formatter: seriesName => '',
            },
          },
        },
        grid: {
          padding: {
            top: -15,
          },
        },
        states: {
          active: {
            filter: {
              type: 'none',
            }
          },
        },
        noData: {
          text: 'Loading...',
          offsetY: -20,
          offsetX: 30,
          style: {
            color: '#858585',
          }
        }
      },
      unusedTopFive: [],
      monthlyUnusedCountChartSeries: [],
      monthlyUnusedCountChartOptions: {
        chart: {
          type: 'bar',
          toolbar: { show: false },
          parentHeightOffset: 0,
          animations: {
            animateGradually: { enabled: false },
          },
        },
        colors: ['#006633ff'],
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '25px',
          },
        },
        dataLabels: { enabled: false },
        xaxis: {
          categories: [],
        },
        yaxis: {
          tickAmount: 2,
          max: max => max < 5 ? 4 : Math.ceil(max / 10) * 10,
          labels: {
            formatter: val => val.toLocaleString()
          }
        },
        tooltip: {
          x: { show: false },
          y: {
            formatter: val => `${val.toLocaleString()}기`,
            title: {
              formatter: seriesName => '',
            },
          },
        },
        states: {
          active: {
            filter: {
              type: 'none',
            }
          },
        },
        noData: {
          text: 'Loading...',
          offsetY: -20,
          style: {
            color: '#858585',
          }
        },
      },
      fields: [
        { key: 'placeName', label: '충전소', sortable: true },
        { key: 'csoEvseNum', label: '충전기 ID', sortable: true },
        { key: 'goneDay', label: '미사용 지속일수', sortable: true },
        { key: 'chargeTime', label: '최종 충전 종료일', sortable: true },
        { key: 'status', label: '최종 상태', sortable: true },
      ],
      items: []
    }
  },
  created() {
    const vm = this;

    // 충전소 목록
    vm.getStationItems();
  },
  methods: {
    async getStationItems() {
      const vm = this;
      const _url = `/onmapi/evse/unusedSearchPlace`;

      try {
        const res = await http.get(_url);

        vm.stationOptions = [ ...res.data.items ];
        if (vm.stationOptions.length > 0) {
          vm.selectedStation = vm.stationOptions.find(ele => ele.placeId === 'all');
          vm.search();
        }

      } catch (err) {
        console.error(err);
      }
    },
    async getUnusedItems() {
      const vm = this;
      const _url = `/onmapi/evse/longTimeUnused`;

      try {
        const res = await http.get(_url, {
          params: { placeId: vm.selectedStation.placeId }
        });

        vm.unusedData = res.data;
        vm.unusedPercentChartSeries = [ vm.unusedData.chart.unusedCount, vm.unusedData.chart.usedCount ]
        vm.unusedPercentChartOptions = {
          ...vm.unusedPercentChartOptions,
          ...{
            subtitle: {
              text: `전체 ${vm.unusedData.chart.totalCount.toLocaleString()} 기`,
            }
          }
        }
        vm.unusedPeriodChartSeries = [{ data: vm.unusedData.ranges.map(ele => ele.count) }]
        vm.unusedTopFive = vm.unusedData.topFive;
        vm.items = vm.unusedData.items;
        vm.updateMonthlyChart();

      } catch (err) {
        console.error(err);
      }
    },
    updateMonthlyChart() {
      const vm = this;
      const categories = vm.unusedData.countByMonth.map(ele => `${ele.mon}월`);
      const series = vm.unusedData.countByMonth.map(ele => ele.count);

      vm.monthlyUnusedCountChartSeries = [{ data: series }];
      vm.monthlyUnusedCountChartOptions = {
        ...vm.monthlyUnusedCountChartOptions,
        ...{
          xaxis: { categories: categories },
        }
      };
    },
    search() {
      const vm = this;
      vm.getUnusedItems();
    },
    reset() {
      const vm = this;

      vm.selectedStation = vm.stationOptions.find(ele => ele.placeId === 'all');
    },
  }
}
</script>